import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { syncAdminModeFromQuery } from './utils/host';
import { bootGoogleAnalyticsFromConsent } from './services/analyticsConsent';
import { bootLinkedInInsightTagFromConsent } from './services/linkedInInsightTag';
import { bootXPixelFromConsent } from './services/xAdsPixel';
import { bootMetaPixelFromConsent } from './services/metaPixel';
import { captureLinkTokenFromUrl } from './utils/sensitiveLinkToken';
import { bootRedditPixelFromConsent } from './services/redditPixel';

// Persist ?admin=true|false into sessionStorage before App renders so
// isAdminHost() returns the correct value on first paint.
syncAdminModeFromQuery();

// Move a no-login email-link token out of the address bar before any
// analytics can see the URL (preference page).
captureLinkTokenFromUrl();

// #2447 — Reddit pixel uses the same consent grant as GA and no-ops until
// REACT_APP_REDDIT_PIXEL_ID is set.
bootRedditPixelFromConsent();

// #1216 — Consent Mode defaults + load GA only if user previously granted.
// Never hardcode measurement ID in public/index.html (duplicate + pre-consent).
// LinkedIn Insight Tag (#2445), the X pixel (#2437) and the Meta Pixel
// (#2442) use the same grant and stay off until REACT_APP_LINKEDIN_PARTNER_ID
// / REACT_APP_X_PIXEL_ID / REACT_APP_META_PIXEL_ID are set.
bootGoogleAnalyticsFromConsent();
bootLinkedInInsightTagFromConsent();
bootXPixelFromConsent();
bootMetaPixelFromConsent();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
